import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { useContext, useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { LanguageContext } from '../../contexts/language'
import content from '../../portfolio'
import './About.css'
import profilePhoto from '../../pictures/photo.jpeg'

const About = () => {
  const { language } = useContext(LanguageContext)
  const { name, role, description, resume, social } = content[language].about
  const [displayedRole, setDisplayedRole] = useState('')
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (!role) return undefined
    
    if (currentIndex < role.length) {
      const timeout = setTimeout(() => {
        setDisplayedRole(prev => prev + role[currentIndex])
        setCurrentIndex(prev => prev + 1)
      }, 50)
      return () => clearTimeout(timeout)
    }
    return undefined
  }, [currentIndex, role])

  useEffect(() => {
    setDisplayedRole('')
    setCurrentIndex(0)
  }, [language, role])

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  }

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  }

  return (
    <motion.div 
      className='about center'
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.img 
        src={profilePhoto} 
        alt={name ? `${name} profile` : 'Profile photo'} 
        className='about__photo'
        variants={itemVariants}
        whileHover={{ scale: 1.05, rotate: 2 }}
        transition={{ type: "spring", stiffness: 300 }}
      />
      
      <motion.div variants={itemVariants}>
        {language === 'de' && content[language].about.greeting && (
          <h1>{content[language].about.greeting}</h1>
        )}
        {language !== 'de' && name && (
          <h1>
            Hi, I am <span className='about__name'>{name}.</span>
          </h1>
        )}
      </motion.div>

      <motion.h2 
        className='about__role'
        variants={itemVariants}
      >
        {language === 'de' ? displayedRole : `A ${displayedRole}.`}
        <motion.span
          animate={{ opacity: [1, 0] }}
          transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
        >
          |
        </motion.span>
      </motion.h2>
      
      <motion.p 
        className='about__desc'
        variants={itemVariants}
      >
        {description && description}
      </motion.p>

      <motion.div 
        className='about__contact center'
        variants={itemVariants}
      >
        {resume && (
          <motion.a 
            href={resume}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span type='button' className='btn btn--outline'>
              Resume
            </span>
          </motion.a>
        )}

        {social && (
          <>
            {social.github && (
              <motion.a
                href={social.github}
                aria-label='github'
                className='link link--icon'
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <GitHubIcon />
              </motion.a>
            )}

            {social.linkedin && (
              <motion.a
                href={social.linkedin}
                aria-label='linkedin'
                className='link link--icon'
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2, rotate: -5 }}
                whileTap={{ scale: 0.9 }}
              >
                <LinkedInIcon />
              </motion.a>
            )}
          </>
        )}
      </motion.div>
    </motion.div>
  )
}

export default About
